import axios from 'axios'
import store from '@state/store'

const state = {
  pageNr: 1,
  statusUpdates: [],
  interest: null,
}

const getters = {
  getPageNr(state) {
    return state.pageNr
  },
  getStatusUpdates(state) {
    return state.statusUpdates
  },
}

const mutations = {
  SET_PAGENR(state, newValue) {
    state.pageNr = newValue
  },
  SET_STATUS_UPDATES(state, newValue) {
    if (state.pageNr === 1) {
      state.statusUpdates = newValue
    } else {
      state.statusUpdates = state.statusUpdates.concat(newValue)
    }
  },
  UPDATE_STATUS_UPDATE(state, newValue) {
    state.statusUpdates.forEach((element, index) => {
      if (element.id === newValue.id) {
        state.statusUpdates[index] = newValue
      }
    })
  },
  SET_INTEREST(state, newValue) {
    state.interest = newValue
  },
}

const actions = {
  fetchStatusUpdates({ commit, dispatch, getters }, { interestId, type }) {
    return axios
      .get(
        `/api/v1/${type}/${interestId}/status_updates/${getters.getPageNr}/type`
      )
      .then((response) => {
        commit('SET_STATUS_UPDATES', response.data)
        commit('SET_PAGENR', getters.getPageNr + 1)
        return response.data
      })
  },
  fetchInterest({ commit, dispatch, getters }, { interestId, type }) {
    return axios.get(`/api/v1/${type}/${interestId}`).then((response) => {
      commit('SET_INTEREST', response.data)
      return response.data
    })
  },
  postNewComment(
    { commit, dispatch, getters },
    { content, statusUpdateId, userId }
  ) {
    return axios
      .post(`/api/v1/comment`, {
        content: content,
        status: 'approved',
        status_update_id: statusUpdateId,
        user_id: userId,
      })
      .then((response) => {
        return response.data
      })
  },
  likeComment({ commit, dispatch, getters }, { commentId }) {
    return axios
      .post(`/api/v1/comments/add_like`, {
        commentId: commentId,
      })
      .then((response) => {
        return response.data
      })
  },
  likePost({ commit, dispatch, getters }, { statusUpdateId }) {
    return axios
      .post(`/api/v1/status_updates/add_like`, {
        statusUpdateId: statusUpdateId,
      })
      .then((response) => {
        return response.data
      })
  },
  fetchFriends({ commit, dispatch }, { startingWith }) {
    return axios
      .get(`/api/v1/friends/startingWith/${startingWith}`)
      .then((response) => {
        return response
      })
  },
  fetchOrganizations({ commit, dispatch }, { startingWith }) {
    return axios
      .get(`/api/v1/charity-organization/startingWith/${startingWith}`)
      .then((response) => {
        return response
      })
  },
  fetchCauses({ commit, dispatch }) {
    return axios.get(`/api/v1/causes`).then((response) => {
      return response
    })
  },
  fetchTags({ commit, dispatch }, { startingWith }) {
    return axios
      .get(`/api/v1/tags/startingWith/${startingWith}`)
      .then((response) => {
        return response
      })
  },
  changeStatus({ commit, dispatch, getters }, { statusUpdateId, status }) {
    return axios
      .post(`/api/v1/status_update/change_status`, {
        status: status,
        status_update_id: statusUpdateId,
      })
      .then((response) => {
        commit('UPDATE_STATUS_UPDATE', response.data)
        return response.data
      })
  },
  toggleFollowInterest(
    { commit, dispatch, getters },
    { interestId, type, entity, isFollowed }
  ) {
    var prefix = ''
    if (isFollowed) {
      prefix = 'un'
    }
    var data = {
      tagId: interestId,
      tagType: type,
    }
    if (type === undefined) {
      data = { organizationId: interestId }
    }
    return axios
      .post(`/api/v1/user/${prefix}follow${entity}`, data)
      .then((response) => {
        const params = {
          tag: response.data.tag,
          wasFollowed: isFollowed,
        }
        store.dispatch('auth/toggleFollowTag', params)
        return response.data
      })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
